import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take, switchMap } from 'rxjs/operators';
import { UserSettingsService } from 'src/app/core/services/user-settings.service';
import type { Entity } from '../../core/models/entity.model';
import { EntityService, PropertyUpdate } from '../../core/services/entity.service';
import type { UserSettings } from '../../core/models/user-settings.model';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsEntitiesService {
  constructor(private entityService: EntityService, private userSettingsService: UserSettingsService) {}

  getUserSettingsEntity(): Observable<Entity[]> {
    return this.userSettingsService.getUserSettings().pipe(
      take(1),
      switchMap(defaultData => {
        const dataToSend = this.dataToDto(defaultData);
        return this.entityService.createOrUpdateTemporaryEntity('UserSettings', dataToSend);
      })
    );
  }

  updateUserSettingsEntity(settings: UserSettings): Observable<Entity[]> {
    return this.entityService.createOrUpdateTemporaryEntity('UserSettings', this.dataToDto(settings));
  }

  dataToDto(data: UserSettings): PropertyUpdate[] {
    const dto: PropertyUpdate[] = [];
    for (const key in data) {
      dto.push({ Key: key, Value: data[key] });
    }
    return dto;
  }
}
